"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useAB;
var _initGrowthBookClient = require("../utils/growthBook/initGrowthBookClient");
/**
 * Custom hook for AB Testing
 */

// import { useContext } from 'react';
// import _get from 'lodash/get';

// import { ABTestingContext } from '@/contexts/abTesting.context';

function useAB(keyName) {
  // const abKeyMap = useContext(ABTestingContext);
  // return keyName ? _get(abKeyMap, keyName, false) : abKeyMap;
  return (0, _initGrowthBookClient.useFeatureIsOn)(keyName);
}